import styled from 'styled-components';
import colors from '../../theme/search/colors';

const Wrapper = styled.div`
  margin-left: 8px;
  margin-right: 8px;
  margin-top: 41px;
  box-shadow: 0 0 5px 0 rgba(150, 150, 150, 0.5);
  cursor: pointer;
  border: 2px solid #ffffff;
  border-top: 0;
  z-index: 1;
  min-width: 320px;

  @media (max-width: 767px) {
    margin-right: 0px;
    margin-left: 0px;
    margin-top: 16px;
  }

  &:hover {
    border-color: #9b9b9b;
  }
  .header {
    border-top: 8px;
    border-bottom: 2px;
    border-left: 0;
    border-right: 0;
    border-color: black;
    border-style: solid;
    padding: 12px;
    font-size: 15px;
    z-index: 2;
    margin-left: -2px;
    margin-right: -2px;
  }

  .card-aligner {
    height: 100%;
  }
  .card-link>*,
  .card-link{
    text-decoration:none;
  }
  .card-link .header{
    color:black;
  }
  .card-container {
    font-size: 14px;
    line-height: 19px;
    padding: 12px;
    border: 0px;
    border-bottom: 1px;
    border-style: solid;
    color: ${colors.blackThree};
    display: flex;
    flex-direction: column;

    @media (min-width: 767px) {
      height: 295px;
    }
  }

  .title {
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
  }

  & .freemium-text {
    color: ${colors.freemium};
    font-size: 14px;
    font-style: italic;
    font-weight: 500;
    line-height: 16px;
  }

  .subtitle {
    color: black;
    font-size: 14px;
    line-height: 17px;
    font-weight: 400;
    padding-top: 6px;
  }

  .type {
    font-size: 12px;
    color: ${colors.gray};
    padding-top: 30px;
    text-transform: uppercase;
  }

  & .date-zone {
    padding-top: 14px;
  }

  .cadena {
    margin-right: 10px;
  }

  .overview-div {
    color: ${colors.gray};
    font-size: 14px;
    font-weight: bold;
    line-height: 16px;
  }

  .authors {
    font-weight: 500;

    p {
      margin: 0;
    }
  }

  .card-wrapper {
    padding-top: 16px;

    @media (min-width: 1024px) {
      height: 170px;
    }
  }

  .site-title {
    text-transform: uppercase;
    color: #000000;
    font-size: 14px;
    line-height: 19px;
  }

  .avail {
    display: flex;
    font-size: 14px;
    line-height: 16px;
    color: ${colors.gray};
    align-items: center;

    svg {
      margin-right: 15px;
    }
  }

  .read {
    display: flex;
    padding: 12px;
    justify-content: flex-end;
    color: ${colors.gray};
    cursor: pointer;

    & span {
      font-size: 15px;
      margin-right: 15px;
    }

    & .icon-animate {
      -webkit-transition: -webkit-transform 0.3s ease-in-out;
      -ms-transition: -ms-transform 0.3s ease-in-out;
      transition: transform 0.3s ease-in-out;
    }

    & path {
      stroke: ${colors.borderSelect};
      fill: ${colors.borderSelect};
    }
  }

  .read:hover {
    color: black;

    & path {
      stroke: black;
      fill: black;
    }
  }

  & .overview {
    padding: 15px;
    font-size: 15px;
    color: ${colors.blackThree}
    line-height: 18px;
    border-top: 1px solid;
  }
`;

const svgStyle = {
  width: 32,
  color: colors.gray
};

export { Wrapper, svgStyle };



// WEBPACK FOOTER //
// ./src/components/ResultCard/style.js